import type { AllRouteEndpoints } from "../routeTypes";

export const generativeAiAgentIdCopyTargetAppGroupIdCacheKeys: AllRouteEndpoints[] = [
  // The copy lands in another workspace, and the modal navigates there after the copy.
];
